import { Teachers } from './Teachers';
export default Teachers;